import { Page } from 'src/Models';
import { API_BASE_URL, ENDPOINTS } from 'src/modules/api/endpoints';
import fetch from 'fetch-retry';

const buildPageSyncParams = (pageData: Page) => ({
  startedWritingAt: pageData.startedWritingAt,
  finishedWritingAt: pageData.finishedWritingAt,
  isDeleted: pageData.isDeleted,
  text: pageData.text,
  updatedAt: pageData.updatedAt,
  createdAt: pageData.createdAt,
  lastSyncDate: pageData.lastSyncDate,
  analysis: pageData.analysis,
  wordsGoal: pageData.wordsGoal,
  writingIntervals: pageData.writingIntervals,
});

const MAX_RETRY_ATTEMPT = 3;

const pageRequest = async (token: string, method: string, payload: any) => {
  const url = `${API_BASE_URL}${ENDPOINTS.PAGES.INDEX}`;
  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(payload),
    retries: 3,
    retryDelay: 1000,
    retryOn(attempt: number, error: Error, resp: any) {
      if (attempt >= MAX_RETRY_ATTEMPT) {
        return false;
      }
      // retry on any network error, or 4xx or 5xx status codes
      if (error !== null || resp.status >= 400) {
        return true;
      } else {
        return false;
      }
    },
  });

  if (!response.ok) {
    const responseBody = await response.text();
    throw new Error(`API request failed. Status: ${response.status}. Body: ${responseBody}`);
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const updatePage = async (token: string, page: Page) => {
  const payload = buildPageSyncParams(page);
  return await pageRequest(token, 'post', payload);
};

export const deletePage = async (token: string, page: Page) => {
  const payload = {
    createdDate: page.createdAt,
    updatedDate: page.updatedAt,
  };
  return await pageRequest(token, 'delete', payload);
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/AuditLog/api.ts